import {
  LOGIN_REQUESTING,
  CLEAR_MESSAGES,
} from './constants'
  
// In order to perform an action of type LOGIN_REQUESTING
// we need an email and password
export const loginRequest = (postData, history) => {
  return {
    type: LOGIN_REQUESTING,
    postData,
    history,
  }
}

export const clearMessages = () => {
  return {
    type: CLEAR_MESSAGES,
  }
}
export default loginRequest


// WEBPACK FOOTER //
// ./src/views/Pages/Login/actions.js